import { API_ENDPOINTS } from 'constants';
import { useFetchData } from 'hooks/apiHooks';
import { useComponentDetails } from 'hooks/useComponentDetails';
import React, { createContext, useContext, useMemo, useState } from 'react';

const CampaignContext = createContext();

export const CampaignProvider = ({ selectedItem, setSelectedItem, context, list, children }) => {
  // Make sure you pass selectedItem or get it from somewhere if it's needed for the API call.
  //const [participants, setParticipants] = useState([]);
  const { data: event, saveData: saveEvent, saveKey: saveEventKey, isLoading: isLoadingEvent, error: errorEvent, saveError: saveErrorEvent, success: successEvent, refetch: refetchEvent, toolbar} = useComponentDetails(API_ENDPOINTS.EVENTS.ITEM(selectedItem.id), list)
  const { data: participants, setData: setParticipants, saveData: saveParticipants, setAndSave: setAndSaveParticipants, saveLineKey: saveParticipantKey, isLoading: isLoadingParticipants, error: errorParticipants, refetch: refetchParticipants, triggerDelete: triggerDeleteParticipants, success: successParticipant } = useFetchData(API_ENDPOINTS.EVENTS.PARTICIPANTS(selectedItem.id), API_ENDPOINTS.EVENTS.PARTICIPANTS(selectedItem.id), true);

  const value = useMemo(() => ({ 
    toolbar,
    selectedItem, setSelectedItem, context, list,
    event, saveEvent, saveEventKey, isLoadingEvent, errorEvent, saveErrorEvent, successEvent, refetchEvent, 
    participants, setParticipants, saveParticipants, setAndSaveParticipants, saveParticipantKey, isLoadingParticipants, errorParticipants, refetchParticipants, triggerDeleteParticipants, successParticipant
  }), [
    toolbar,
    selectedItem, setSelectedItem, context, list,
    event, saveEvent, saveEventKey, isLoadingEvent, errorEvent, 
    saveErrorEvent, successEvent, refetchEvent, 
    participants, setParticipants, saveParticipants, setAndSaveParticipants, saveParticipantKey, isLoadingParticipants, 
    errorParticipants, refetchParticipants, triggerDeleteParticipants, successParticipant,
  ]);


  return (
    <CampaignContext.Provider value={value}>
      {children}
    </CampaignContext.Provider>
  );
};

export const useCampaignContext = () => {
  const context = useContext(CampaignContext);
  if (!context) {
    throw new Error('useCampaignContext must be used within a CampaignProvider');
  }
  return context;
};
